import {
  getSortByOptions,
  GuestRatingOptions,
  getHotelClassOptions,
  getPriceFilterOptions,
  getPriceFilterOptionsHotel,
  getPaymentCancellationOptions,
  getPriceFilterOptionsConfing,
} from '@airasia-common/libraries/constants';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import Expander from '@airasia/phoenix-components/components/Expander';
import { array, bool, func, number, object, string } from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import loadableVisibility from 'react-loadable-visibility/loadable-components';
import Styled from '../../utils/Styled';
import Button from '../Button';
import Row from '../Container/Row';
import Divider from '../Divider';
import { BodyText, H3 } from '../Text/Heading';
import Wrapper from '../Wrapper';
import Icon from '../Icon';
const Checklist = loadableVisibility(() =>
  import(
    /* webpackChunkName:"Checklist" */ '@airasia/phoenix-components/components/Checklist'
  )
);
const DropDown = loadableVisibility(() =>
  import(
    /* webpackChunkName:"DropDown" */ '@airasia/phoenix-components/components/Dropdown'
  )
);
const HotelNameSearchWidget = loadableVisibility(() =>
  import(
    /* webpackChunkName:"HotelNameSearchWidget" */ '@airasia/phoenix-widgets/widgets/HotelNameSearchWidget'
  )
);
const GuestRatingSelection = loadableVisibility(() =>
  import(
    /* webpackChunkName:"GuestRatingSelection" */ '../GuestRatingSelection'
  )
);
const CollapsibleRadioGroup = loadableVisibility(() =>
  import(
    /* webpackChunkName:"CollapsibleRadioGroup" */ '../Radio/CollapsibleRadioGroup'
  )
);
const RadioGroup = loadableVisibility(() =>
  import(/* webpackChunkName:"RadioGroup" */ '../Radio/RadioGroup')
);
const CheckboxesGroup = loadableVisibility(() =>
  import(
    /* webpackChunkName:"CheckboxesGroup" */ '../CheckboxesGroup/CheckboxesGroup'
  )
);
const CollapsibleCheckboxesGroup = loadableVisibility(() =>
  import(
    /* webpackChunkName:"CheckboxesGroup" */ '../CheckboxesGroup/CollapsibleCheckboxesGroup'
  )
);

const Chip = loadableVisibility(() =>
  import(
    /* webpackChunkName:"Checklist" */ '@airasia/phoenix-components/components/Chip'
  )
);

const DESKTOP_VIEWPORT = 'desktop';
const MOBILE_VIEWPORT = 'mobile';
const LOCALE = {
  noResultLabel: 'There is no result for {0}',
  loadOptions: 'Options are loading',
  recentSearch: 'Recent Searches',
  noRightKeywordLabel: 'Please enter right type of keyword',
  clear: 'Clear',
  searchForLabel: 'Search For {0}',
};
const HeaderWrapper = styled(Row)`
  height: 56px;
  align-items: center;
  top: 0;
  width: 100%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  background-color: ${({ theme }) => theme.colors.primaryWhite};
`;
const LeftIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  margin: 16px;
  color: ${({ theme }) => theme.colors.greyDark};
`;
const TextWrapper = styled(Row)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const ResetButton = Styled(BodyText, {
  fontSize: ['16px', '14px'],
  color: 'primary',
  mr: 4,
  cursor: 'pointer',
  margin: 'auto',
});

const NewResetButton = Styled(BodyText, {
  fontSize: ['16px', '14px'],
  color: '#4B4FA6',
  mr: 4,
  cursor: 'pointer',
  margin: 'auto',
});

const MoveResetButton = Styled(BodyText, {
  fontSize: ['16px', '14px'],
  color: '#8D1414',
  mr: 4,
  cursor: 'pointer',
  margin: 'auto',
});

const FilterDivider = styled(Divider)`
  margin: 32px 0;
`;

const StyledFilterDivider = styled(Divider)`
  margin: 20px 0;
`;

const FilterFooter = styled(Row)`
  box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.04);
  position: fixed;
  bottom: 0;
  width: stretch;
`;
const SortAndFilterLabel = styled(H3)`
  color: ${({ theme }) => theme.colors.greyDark};
`;

const FilterLabel = styled(H3)`
  color: ${({ theme }) => theme.colors.darkBlack};
`;

const PerGuestText = styled.span`
  font-size: 12px;
  margin-left: 5px;
  color: ${({ theme }) => theme.colors.greyDark};
`;

const StyledFilterChipWrapper = styled(Wrapper)`
  flex-wrap: wrap;
  justifycontent: 'flex-start';
  height: ${props => (props.items > 6 ? '240px' : 'auto')};
  margin-top: 8px;
`;

const StyledAdditionChipWrapper = styled(Wrapper)`
  overflow: auto;
  height: ${props => (props.items > 6 ? '240px' : 'auto')};
`;

const ChipWrapper = styled(Wrapper)`
  padding-bottom: 12px;
  padding-right: 5px;
  float: left;
`;

const SortAndFilter = ({
  isMobile,
  closeModal,
  filter,
  clearFilter,
  updateFilter,
  hasMapView,
  hotelClassSelectionHandler,
  isShowChecklist,
  sendAmenitiesId,
  initialAmenities,
  isShowInputFilter,
  listFilterItems,
  defaultItemFilter,
  filterPlaceHolder,
  searchInputHandle,
  onClear,
  onSelectItemFilter,
  locationOptions,
  isLocationFilterEnabled,
  selectedLocationId,
  locationSelectionHandler,
  confFilterLocale,
  cancelIconColor,
  onUpdateFilterTrigger,
  isEmpty,
  data,
  locale,
  lat,
  lon,
  clientId,
  dest,
  onSelectDropdownOptions,
  enableHotelNameSearch,
  onApplyButtonClick,
  hotelNameObj,
  resetHotelName,
  isHotelNameSearchOptionFullWidth,
  showSearchIconHotelNameSearch,
  showAbleLocationLength,
  environment,
  sortBySelectionHandler,
  guestRatingSelectionHandler,
  priceFilterHandler,
  showAbleAmenityLength,
  showFilterAccordion,
  userLocationSelected,
  lob,
  isNeighborhoodFilterEnabled,
  neighborhoodOptions,
  neighborhoodSelectionHandler,
  setResetLocationFilter,
  resetLocationFilter,
  showPaymentAndCancellationPolicyFilter,
  paymentAndCancellationPolicyHandler,
  fireGtm,
  isHotelSearchWidget,
  isForListingPage,
  showPropertyType,
  propertyTypeSelectionHandler,
  initialPropertyTypes,
  showAblePropertyTypeLength,
  isSnap,
  isHotel,
  hotel,
  showPromotionFilter,
  promotionFilterSelectionHandler,
  showPromotionFilterCheckBox,
  filteredData,
  localizedText,
  unFilter,
  enableFilterPlacement,
  enableFilterRearrange,
  enableFreeCancellation,
  enablePayNowFilter,
  enableSortByV2,
  enableGuestRatingDeselect,
  theme,
  isMoveEnabled,
  enablePayLaterFilter,
  enablePriceBucketsConfig,
  priceRange,
  isTotalGuestPriceEnable,
}) => {
  const history = useHistory();
  let { location } = history;
  const { defaultFilter } = filter;
  const [draftFilter, setDraftFilter] = useState(filter);
  const [amenities, setAmenities] = useState(filter.amenities);
  const [propertyTypes, setPropertyTypes] = useState(filter.propertyType);
  const [defaultItem, setDefaultItem] = useState(defaultItemFilter);
  const [locationObject, setLocationObject] = useState(filter.locationObject);
  const [neighbourhoodObject, setNeighbourhoodObject] = useState(
    filter.locationId
  );
  const [useLocationDestination, setUseLocationDestination] = useState('');
  const showLessText = translate(
    isMoveEnabled ? 'common.showLess' : 'amenityFilter.filter_seemore'
  );
  const showMoreText = translate(
    isMoveEnabled ? 'roomCard.showMore' : 'amenityFilter.filter_seeless'
  );
  const HOTEL_LOB = 'Hotel';
  const move = isMoveEnabled;
  useEffect(() => {
    setDraftFilter(filter);
  }, [filter]);
  const clearHotelNameSearch = useCallback(() => {
    setDraftFilter({
      ...draftFilter,
      aaId: '',
      hotelNameObj: {},
      locationId: filter.locationId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftFilter]);
  const localOnSelectHotelSearchOption = useCallback(
    item => {
      if (item && item.aa_id && item.name) {
        setDraftFilter({
          ...draftFilter,
          aaId: item.aa_id,
          hotelNameObj: { ...draftFilter.hotelNameObj, name: item.name },
          filterItemId: '',
          focusId: '',
        });
      }
    },
    [draftFilter]
  );
  const localOnSelectDropDownOptions = useCallback(
    item => {
      if (onSelectDropdownOptions) {
        onSelectDropdownOptions(item);
        return;
      }
      if (!item) {
        clearHotelNameSearch();
        return;
      }
      localOnSelectHotelSearchOption(item);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [draftFilter]
  );
  useEffect(() => {
    setUseLocationDestination(filter.locationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (hotelNameObj && hotelNameObj.name !== null) {
      setDraftFilter({
        ...draftFilter,
        hotelNameSearch: true,
      });
    } else {
      setDraftFilter({
        ...draftFilter,
        hotelNameSearch: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hotelNameObj]);
  const isLocationIdDifferent = () => {
    if (lob === HOTEL_LOB) {
      return resetLocationFilter;
    } else {
      let isDifferent = draftFilter.locationId !== defaultFilter.locationId;
      if (locationOptions.length !== 0) {
        isDifferent =
          isDifferent && selectedLocationId !== locationOptions[0].id;
      }
      return isDifferent;
    }
  };
  const isResetButtonVisible = !!draftFilter;
  const defaultFilterSearch = { filterItemId: '' };
  const onfilterChangeValue = (inputValue, callback, items) => {
    const result =
      inputValue && inputValue !== '' && inputValue !== null
        ? listFilterItems.filter(option =>
            option.mainDisplayName
              .toLowerCase()
              .startsWith(inputValue.toLowerCase())
          )
        : listFilterItems;
    if (searchInputHandle) searchInputHandle(inputValue);
    callback(result);
  };
  const clearFocus = () => {
    try {
      const query = new URLSearchParams(location.search);
      if (query.get('focusId')) {
        query.delete('focusId');
        location.search = query.toString();
        history.push(location);
      }
      if (query.get('aaId')) {
        query.delete('aaId');
        location.search = query.toString();
        history.push(location);
      }
    } catch (ex) {
      console.error(ex);
    }
  };
  const onSelectFilter = item => {
    if (onSelectItemFilter) onSelectItemFilter(item);
    if (item.value) {
      setDraftFilter({ ...draftFilter, filterItemId: item.value });
    }
  };
  const onClearFilter = () => {
    if (onClear) onClear();
    setDraftFilter({ ...draftFilter, filterItemId: '' });
  };
  const locationFilterIdHotels = () => {
    if (lob === HOTEL_LOB) {
      if (userLocationSelected) {
        return userLocationSelected;
      } else {
        return useLocationDestination;
      }
    }
  };
  const onReset = () => {
    clearFocus();
    clearFilter();
    setResetLocationFilter(false);
    setDraftFilter({
      ...draftFilter,
      ...defaultFilter,
      ...defaultFilterSearch,
      locationId: locationFilterIdHotels(),
    });
    isLocationFilterEnabled &&
      updateFilter({
        ...draftFilter,
        ...defaultFilter,
        locationFilterSelected: false,
      });
    isShowChecklist && sendAmenitiesId([]);
    hotelClassSelectionHandler([]);
    showPropertyType && propertyTypeSelectionHandler([]);
    showPaymentAndCancellationPolicyFilter &&
      paymentAndCancellationPolicyHandler([]);
    enableFreeCancellation && paymentAndCancellationPolicyHandler([]);
    priceFilterHandler([]);
    enableHotelNameSearch && resetHotelName();
    isLocationFilterEnabled &&
      updateFilter({
        ...draftFilter,
        ...defaultFilter,
        locationFilterSelected: false,
      });
    closeModal();
    showPromotionFilter && promotionFilterSelectionHandler([]);
  };
  useEffect(() => {
    if (!isMobile) {
      if (
        draftFilter.sortBy !== filter.sortBy ||
        draftFilter.guestRating !== filter.guestRating ||
        draftFilter.hotelClass !== filter.hotelClass ||
        draftFilter.amenities !== filter.amenities ||
        draftFilter.propertyType !== filter.propertyType ||
        draftFilter.locationId !== filter.locationId ||
        draftFilter.priceFilter !== filter.priceFilter ||
        draftFilter.aaId !== filter.aaId ||
        draftFilter.paymentType !== filter.paymentType ||
        draftFilter.promotions !== filter.promotions ||
        draftFilter.hotelNameSearch !== filter.hotelNameSearch
      ) {
        updateFilter({ ...draftFilter, filterItemId: '' });
        if (onUpdateFilterTrigger) onUpdateFilterTrigger();
      }
    }
    //TODO: so that this wont make 2 call when apply is pressed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, draftFilter, updateFilter]);
  useEffect(() => {
    !isMobile && priceFilterHandler(draftFilter.priceFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftFilter.priceFilter]);
  useEffect(() => {
    !isMobile && hotelClassSelectionHandler(draftFilter.hotelClass);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftFilter.hotelClass]);

  useEffect(() => {
    !isMobile &&
      showPaymentAndCancellationPolicyFilter &&
      paymentAndCancellationPolicyHandler(draftFilter.paymentType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftFilter.paymentType]);
  useEffect(() => {
    !isMobile &&
      enableFreeCancellation &&
      paymentAndCancellationPolicyHandler(draftFilter.paymentType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftFilter.paymentType]);
  useEffect(() => {
    !isMobile &&
      showPromotionFilter &&
      promotionFilterSelectionHandler(draftFilter.promotions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftFilter.promotions]);
  const showSortBy = () => {
    return (
      <>
        <RadioGroup
          isMoveEnabled={isMoveEnabled}
          className="sort-options"
          isVertical
          options={getSortByOptions(translate)}
          selectedId={draftFilter.sortBy}
          onChange={sortBy => {
            setDraftFilter({
              ...draftFilter,
              sortBy: sortBy.id,
            });
            sortBySelectionHandler(sortBy);
          }}
        />
        <FilterDivider />
      </>
    );
  };
  const showPriceFilter = () => {
    return (
      <>
        <CheckboxesGroup
          isMoveEnabled={isMoveEnabled}
          theme={theme}
          options={
            enablePriceBucketsConfig
              ? getPriceFilterOptionsConfing(filter.currency, priceRange)
              : lob === HOTEL_LOB
              ? getPriceFilterOptionsHotel(filter.currency)
              : getPriceFilterOptions(filter.currency)
          }
          displayTextProp="value"
          selectedOptions={draftFilter.priceFilter}
          onChange={item => {
            setDraftFilter({
              ...draftFilter,
              priceFilter: [...item],
            });
          }}
        />
        {!showPromotionFilter && <FilterDivider />}
      </>
    );
  };
  const showGuestRatingFilter = () => {
    const isDeselectEnabled = enableGuestRatingDeselect;
    return (
      <>
        <GuestRatingSelection
          theme={theme}
          options={GuestRatingOptions}
          selectedId={draftFilter.guestRating}
          onChange={guestRating => {
            setDraftFilter({
              ...draftFilter,
              guestRating: isDeselectEnabled
                ? draftFilter.guestRating === guestRating.id
                  ? ''
                  : guestRating.id
                : guestRating.id,
              aaId: '',
              hotelNameObj: {},
            });
            guestRatingSelectionHandler(guestRating);
          }}
          isDeselectEnabled={isDeselectEnabled}
          isMoveEnabled={isMoveEnabled}
        />
        <FilterDivider />
      </>
    );
  };
  const showPropertyTypeFilterSnap = () => {
    return (
      <>
        <CollapsibleCheckboxesGroup
          theme={theme}
          isMoveEnabled={isMoveEnabled}
          options={initialPropertyTypes}
          displayTextProp="value"
          selectedOptions={draftFilter.propertyType}
          onChange={value => {
            setDraftFilter({
              ...draftFilter,
              propertyType: [...value],
            });
            propertyTypeSelectionHandler(value);
          }}
          showAbleLength={showAblePropertyTypeLength}
        />
        <FilterDivider />
      </>
    );
  };
  const showHotelStarRatingFilter = () => {
    return (
      <>
        <CheckboxesGroup
          isMoveEnabled={isMoveEnabled}
          theme={theme}
          options={getHotelClassOptions(translate)}
          displayTextProp="value"
          selectedOptions={draftFilter.hotelClass}
          onChange={item => {
            setDraftFilter({
              ...draftFilter,
              hotelClass: [...item],
            });
          }}
        />
        <FilterDivider />
      </>
    );
  };
  const showPaymentTypeFilter = () => {
    return (
      <>
        <CheckboxesGroup
          isMoveEnabled={isMoveEnabled}
          theme={theme}
          options={getPaymentCancellationOptions(
            translate,
            isSnap,
            enablePayNowFilter,
            enablePayLaterFilter
          )}
          displayTextProp="value"
          selectedOptions={draftFilter.paymentType}
          onChange={item => {
            setDraftFilter({
              ...draftFilter,
              paymentType: [...item],
            });
          }}
        />
        <FilterDivider />
      </>
    );
  };
  const showFreeCancellationFilter = () => {
    return (
      <>
        <CheckboxesGroup
          isMoveEnabled={isMoveEnabled}
          theme={theme}
          options={getPaymentCancellationOptions(translate, isSnap)}
          displayTextProp="value"
          selectedOptions={draftFilter.paymentType}
          onChange={item => {
            setDraftFilter({
              ...draftFilter,
              paymentType: [...item],
            });
          }}
        />
        <FilterDivider />
      </>
    );
  };
  const showAmenitiesFilter = () => {
    return (
      <>
        <PhoenixTheme>
          <Checklist
            onListSelection={value => {
              setDraftFilter({
                ...draftFilter,
                amenities: value,
              });
              setAmenities(value);
              !isMobile && sendAmenitiesId(value);
            }}
            initialShownItem={
              showFilterAccordion
                ? initialAmenities?.length
                : showAbleAmenityLength
            }
            data={initialAmenities}
            showLessBtn={!showFilterAccordion}
            theme={theme}
            isMoveEnabled={isMoveEnabled}
            isTextBold={false}
            textType={'sub'}
            showLessText={showLessText}
            showMoreText={showMoreText}
            bottomOverlay
            isIndentItem
            showMoreTextColor={isMoveEnabled ? 'darkRed' : 'secondary'}
            isShowMoreTextBold
            activeColor={isMoveEnabled && '#023C40'}
            showMoreIcon={isMoveEnabled}
            showLessIcon={isMoveEnabled}
          />
        </PhoenixTheme>
        <FilterDivider />
      </>
    );
  };
  const showlocationFilter = accordionTitle => {
    return (
      <>
        <CollapsibleRadioGroup
          theme={theme}
          isMoveEnabled={isMoveEnabled}
          options={locationOptions}
          selectedId={draftFilter.locationId || selectedLocationId}
          onChange={clickedLocation => {
            if (selectedLocationId !== clickedLocation.id || isMobile) {
              setDraftFilter({
                ...draftFilter,
                locationId: clickedLocation.id,
                locationObject: clickedLocation,
                locationFilterSelected: isSnap
                  ? locationOptions &&
                    locationOptions.length > 0 &&
                    clickedLocation.id
                  : locationOptions &&
                    locationOptions.length > 0 &&
                    locationOptions[0].id !== clickedLocation.id,
              });
              setLocationObject(clickedLocation);
              !isMobile && locationSelectionHandler(clickedLocation);
            }
          }}
          title={accordionTitle ? '' : translate('locationFilter.title')}
          showableLength={
            accordionTitle ? locationOptions?.length : showAbleLocationLength
          }
        />
        <FilterDivider />
      </>
    );
  };
  const showNeighbourhoodFilter = accordionTitle => {
    return (
      <>
        <CollapsibleRadioGroup
          theme={theme}
          isMoveEnabled={isMoveEnabled}
          options={neighborhoodOptions}
          selectedId={draftFilter.locationId}
          onChange={clickedNeighborhood => {
            setDraftFilter({
              ...draftFilter,
              locationId: clickedNeighborhood?.id,
              locationFilterSelected: clickedNeighborhood?.id,
            });
            setNeighbourhoodObject(clickedNeighborhood);
            !isMobile && neighborhoodSelectionHandler(clickedNeighborhood);
          }}
          title={
            accordionTitle ? '' : translate('sortAndFilter.neighbourhood.title')
          }
          showableLength={
            accordionTitle ? locationOptions?.length : showAbleLocationLength
          }
        />
        {neighborhoodOptions?.length !== 0 && <FilterDivider />}
      </>
    );
  };
  const showPromotionFilterType = () => {
    const getPromotionFilterOptions = translate => {
      const promotionText = translate('sortAndFilter.promotionFilter');
      const comboSavingsText = isTotalGuestPriceEnable
        ? translate('sortAndFilter.bundleSaving')
        : translate('hotelCard.comboSavings');

      if (!isSnap)
        return [{ id: 'promotionFilter', value: `${promotionText}` }];

      if (!showPromotionFilterCheckBox)
        return [{ id: 'comboSavings', value: `${comboSavingsText}` }];

      return [
        { id: 'promotionAndOfferFilter', value: `${promotionText}` },
        { id: 'comboSavings', value: `${comboSavingsText}` },
      ];
    };
    return (
      <>
        {Boolean(showPromotionFilter) && (
          <>
            <FilterDivider />
            <BodyText id="promotions-filter-title" marginBottom={4}>
              {translate('sortAndFilter.promotionsFilterTitle')}
            </BodyText>
            <Row marginTop="-9px">
              <CheckboxesGroup
                isMoveEnabled={isMoveEnabled}
                theme={theme}
                options={getPromotionFilterOptions(translate)}
                displayTextProp="value"
                selectedOptions={draftFilter.promotions}
                onChange={item => {
                  setDraftFilter({
                    ...draftFilter,
                    promotions: [...item],
                  });
                }}
              />
            </Row>
            <FilterDivider />
          </>
        )}
      </>
    );
  };

  const showFilteredData = () => {
    return (
      <StyledFilterChipWrapper items={filteredData.length}>
        <StyledAdditionChipWrapper items={filteredData.length}>
          <PhoenixTheme theme={theme}>
            {filteredData.map((data, i) => (
              <ChipWrapper key={i}>
                <Chip
                  active={true}
                  fontSize="small"
                  rightIcon="CloseIcon"
                  withPadding={true}
                  onIconClick={() => {
                    unFilter({
                      id: data.id,
                      filterType: data.filterType,
                    });
                  }}
                  theme={theme}
                >
                  {localizedText({
                    id: data.id,
                    filterType: data.filterType,
                    filter,
                    enablePriceBucketsConfig,
                    priceRange,
                    isTotalGuestPriceEnable,
                  })}
                </Chip>
              </ChipWrapper>
            ))}
          </PhoenixTheme>
        </StyledAdditionChipWrapper>
      </StyledFilterChipWrapper>
    );
  };
  return (
    <>
      {enableFilterRearrange && !isSnap ? (
        <>
          {isMobile ? (
            <HeaderWrapper>
              <LeftIcon
                icon="CloseIcon"
                id="close-modal-btn"
                onClick={closeModal}
              />
              <TextWrapper>
                <BodyText id="mobile-sort-title">
                  {translate('sortAndFilter.title')}
                </BodyText>
                {isResetButtonVisible &&
                  (theme == 'AIRASIA_MOVE' ? (
                    <MoveResetButton id="mobile-reset-btn" onClick={onReset}>
                      {translate('sortAndFilter.reset')}
                    </MoveResetButton>
                  ) : (
                    <ResetButton id="mobile-reset-btn" onClick={onReset}>
                      {translate('sortAndFilter.reset')}
                    </ResetButton>
                  ))}
              </TextWrapper>
            </HeaderWrapper>
          ) : (
            <Wrapper
              marginTop={hasMapView ? 34 : enableFilterPlacement ? 16 : 58}
              display="flex"
              justifyContent="space-between"
            >
              {enableFilterPlacement ? (
                <>
                  <FilterLabel id="filter-title">
                    {translate('sortAndFilter.filter')}
                  </FilterLabel>
                  {isResetButtonVisible &&
                    (theme == 'AIRASIA_MOVE' ? (
                      <MoveResetButton id="reset-btn" onClick={onReset}>
                        {translate('sortAndFilter.reset')}
                      </MoveResetButton>
                    ) : (
                      <NewResetButton id="reset-btn" onClick={onReset}>
                        {translate('sortAndFilter.reset')}
                      </NewResetButton>
                    ))}
                </>
              ) : (
                <>
                  <SortAndFilterLabel id="sort-title">
                    {translate('sortAndFilter.title')}
                  </SortAndFilterLabel>
                  {isResetButtonVisible &&
                    (theme == 'AIRASIA_MOVE' ? (
                      <MoveResetButton id="reset-btn" onClick={onReset}>
                        {translate('sortAndFilter.reset')}
                      </MoveResetButton>
                    ) : (
                      <ResetButton id="reset-btn" onClick={onReset}>
                        {translate('sortAndFilter.reset')}
                      </ResetButton>
                    ))}
                </>
              )}
            </Wrapper>
          )}
          <Wrapper
            padding={
              isMobile
                ? '24px 16px 80px 16px'
                : enableFilterPlacement
                ? '0 0 0 0'
                : '19px 0 0 0'
            }
          >
            <Wrapper>
              {showFilterAccordion ? (
                <PhoenixTheme theme={theme}>
                  {!enableFilterPlacement && (
                    <Expander
                      label={
                        <BodyText
                          id="sortby-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('sortAndFilter.sortBy')}
                        </BodyText>
                      }
                      id="sort-options-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showSortBy()}
                    </Expander>
                  )}
                </PhoenixTheme>
              ) : (
                <>
                  {enableFilterPlacement ? (
                    <>
                      {showFilteredData()}
                      <StyledFilterDivider />
                    </>
                  ) : (
                    <>
                      <BodyText id="sortby-title">
                        {translate('sortAndFilter.sortBy')}
                      </BodyText>
                      {showSortBy()}
                    </>
                  )}
                </>
              )}
            </Wrapper>
            {enableHotelNameSearch && (
              <Wrapper>
                <BodyText id="hotel-class-title" marginBottom={16}>
                  {translate('sortAndFilter.searchProperty')}
                </BodyText>
                <PhoenixTheme theme={theme}>
                  <HotelNameSearchWidget
                    theme={theme}
                    move={isMoveEnabled}
                    data={data}
                    locale={locale}
                    lat={lat}
                    lon={lon}
                    clientId={clientId}
                    dest={dest}
                    onSelectDropdownOptions={localOnSelectDropDownOptions}
                    isFullWidth={isHotelNameSearchOptionFullWidth}
                    showSearchIcon={showSearchIconHotelNameSearch}
                    viewport={!isMobile ? DESKTOP_VIEWPORT : MOBILE_VIEWPORT}
                    hotelNameObj={hotelNameObj || draftFilter.hotelNameObj}
                    environment={environment}
                    fireGtm={fireGtm}
                    isHotelSearchWidget={isHotelSearchWidget}
                    isForListingPage={isForListingPage}
                    highlightText
                  />
                </PhoenixTheme>
                <FilterDivider />
              </Wrapper>
            )}
            {
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="price-filter-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('sortAndFilter.priceFilter.yourBudget')}
                          <PerGuestText>
                            {' '}
                            ({translate('common.pricePerRoom')})
                          </PerGuestText>
                        </BodyText>
                      }
                      id="price-filter-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showPriceFilter()}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  <>
                    <BodyText id="price-filter-title" marginBottom={2}>
                      {translate('sortAndFilter.priceFilter.yourBudget')}
                      <PerGuestText>
                        {' '}
                        ({translate('common.pricePerRoom')})
                      </PerGuestText>
                    </BodyText>
                    {showPriceFilter()}
                  </>
                )}
              </Wrapper>
            }
            <Wrapper>
              {showFilterAccordion ? (
                <PhoenixTheme theme={theme}>
                  <Expander
                    label={
                      <BodyText
                        id="hotel-class-title"
                        marginBottom={8}
                        marginTop={8}
                      >
                        {translate('sortAndFilter.promotionsFilterTitle')}
                      </BodyText>
                    }
                    id="hotel-class-title-accordion"
                    afterIcon="ExpandLessIcon"
                    beforeIcon="ExpandMoreIcon"
                    isCompact={true}
                  >
                    {showPromotionFilterType()}
                  </Expander>
                </PhoenixTheme>
              ) : (
                <>{showPromotionFilterType()}</>
              )}
            </Wrapper>
            {
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="hotel-class-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('sortAndFilter.hotelClass')}
                        </BodyText>
                      }
                      id="hotel-class-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showHotelStarRatingFilter()}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  <>
                    <BodyText id="hotel-class-title" marginBottom={16}>
                      {translate('sortAndFilter.hotelClass')}
                    </BodyText>
                    {showHotelStarRatingFilter()}
                  </>
                )}
              </Wrapper>
            }
            {showPropertyType &&
              initialPropertyTypes &&
              initialPropertyTypes.length > 0 && (
                <Wrapper>
                  {showFilterAccordion ? (
                    <PhoenixTheme theme={theme}>
                      <Expander
                        label={
                          <BodyText
                            id="propertyType-class-title"
                            marginBottom={8}
                            marginTop={8}
                          >
                            {translate('common.propertyTypes')}
                          </BodyText>
                        }
                        id="propertyType-title-accordion"
                        afterIcon="ExpandLessIcon"
                        beforeIcon="ExpandMoreIcon"
                        isCompact={true}
                      >
                        {showPropertyTypeFilterSnap(true)}
                      </Expander>
                    </PhoenixTheme>
                  ) : (
                    <>
                      <BodyText id="propertyType-class-title" marginBottom={16}>
                        {translate('common.propertyTypes')}
                      </BodyText>
                      {showPropertyTypeFilterSnap()}
                    </>
                  )}
                </Wrapper>
              )}
            <Wrapper>
              {showFilterAccordion ? (
                <PhoenixTheme theme={theme}>
                  <Expander
                    label={
                      <BodyText
                        id="guest-rating-title"
                        marginBottom={8}
                        marginTop={8}
                      >
                        {translate('sortAndFilter.guestRating')}
                      </BodyText>
                    }
                    id="guest-rating-title-accordion"
                    afterIcon="ExpandLessIcon"
                    beforeIcon="ExpandMoreIcon"
                    isCompact={true}
                  >
                    {showGuestRatingFilter()}
                  </Expander>
                </PhoenixTheme>
              ) : (
                <>
                  <BodyText id="guest-rating-title" marginBottom={16}>
                    {translate('sortAndFilter.guestRating')}
                  </BodyText>
                  {showGuestRatingFilter()}
                </>
              )}
            </Wrapper>
            {isLocationFilterEnabled && (
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="locationFilter-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('locationFilter.title')}
                        </BodyText>
                      }
                      id="locationFilter-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showlocationFilter(true)}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  showlocationFilter()
                )}
              </Wrapper>
            )}
            {isNeighborhoodFilterEnabled && (
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="NeighbourhoodFilter-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('sortAndFilter.neighbourhood.title')}
                        </BodyText>
                      }
                      id="NeighbourhoodFilter-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showNeighbourhoodFilter(true)}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  showNeighbourhoodFilter()
                )}
              </Wrapper>
            )}
            {isShowChecklist && (
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="amenities-rating-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('common.amenities')}
                        </BodyText>
                      }
                      id="amenities-rating-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showAmenitiesFilter()}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  <>
                    <BodyText id="amenities-rating-title" marginBottom={16}>
                      {translate('common.amenities')}
                    </BodyText>
                    {showAmenitiesFilter()}
                  </>
                )}
              </Wrapper>
            )}
            {showPaymentAndCancellationPolicyFilter && (
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="paymentType-class-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate(
                            'sortAndFilter.paymentAndCancellationPolicy'
                          )}
                        </BodyText>
                      }
                      id="paymentType-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showPaymentTypeFilter()}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  <>
                    <BodyText id="paymentType-title" marginBottom={16}>
                      {translate('sortAndFilter.paymentType')}
                    </BodyText>
                    {showPaymentTypeFilter()}
                  </>
                )}
              </Wrapper>
            )}
            {enableFreeCancellation && (
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="paymentType-class-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate(
                            'sortAndFilter.paymentAndCancellationPolicy'
                          )}
                        </BodyText>
                      }
                      id="paymentType-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showFreeCancellationFilter()}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  <>
                    <BodyText id="paymentType-title" marginBottom={16}>
                      {translate('sortAndFilter.paymentType')}
                    </BodyText>
                    {showFreeCancellationFilter()}
                  </>
                )}
              </Wrapper>
            )}
          </Wrapper>
        </>
      ) : (
        <>
          {isMobile ? (
            <HeaderWrapper>
              <LeftIcon
                icon="CloseIcon"
                id="close-modal-btn"
                onClick={closeModal}
              />
              <TextWrapper>
                <BodyText id="mobile-sort-title">
                  {translate('sortAndFilter.title')}
                </BodyText>
                {isResetButtonVisible &&
                  (theme == 'AIRASIA_MOVE' ? (
                    <MoveResetButton id="mobile-reset-btn" onClick={onReset}>
                      {translate('sortAndFilter.reset')}
                    </MoveResetButton>
                  ) : (
                    <ResetButton id="mobile-reset-btn" onClick={onReset}>
                      {translate('sortAndFilter.reset')}
                    </ResetButton>
                  ))}
              </TextWrapper>
            </HeaderWrapper>
          ) : (
            <Wrapper
              marginTop={hasMapView ? 34 : enableFilterPlacement ? 16 : 58}
              display="flex"
              justifyContent="space-between"
            >
              {enableFilterPlacement ? (
                <>
                  <FilterLabel id="filter-title">
                    {translate('sortAndFilter.filter')}
                  </FilterLabel>
                  {isResetButtonVisible &&
                    (theme == 'AIRASIA_MOVE' ? (
                      <MoveResetButton id="reset-btn" onClick={onReset}>
                        {translate('sortAndFilter.reset')}
                      </MoveResetButton>
                    ) : (
                      <NewResetButton id="reset-btn" onClick={onReset}>
                        {translate('sortAndFilter.reset')}
                      </NewResetButton>
                    ))}
                </>
              ) : (
                <>
                  <SortAndFilterLabel id="sort-title">
                    {translate('sortAndFilter.title')}
                  </SortAndFilterLabel>
                  {isResetButtonVisible &&
                    (theme == 'AIRASIA_MOVE' ? (
                      <MoveResetButton id="reset-btn" onClick={onReset}>
                        {translate('sortAndFilter.reset')}
                      </MoveResetButton>
                    ) : (
                      <ResetButton id="reset-btn" onClick={onReset}>
                        {translate('sortAndFilter.reset')}
                      </ResetButton>
                    ))}
                </>
              )}
            </Wrapper>
          )}
          <Wrapper
            padding={
              isMobile
                ? '24px 16px 80px 16px'
                : enableFilterPlacement
                ? '0 0 0 0'
                : '19px 0 0 0'
            }
          >
            <Wrapper>
              {showFilterAccordion ? (
                <PhoenixTheme theme={theme}>
                  {!enableFilterPlacement && (
                    <Expander
                      label={
                        <BodyText
                          id="sortby-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('sortAndFilter.sortBy')}
                        </BodyText>
                      }
                      id="sort-options-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showSortBy()}
                    </Expander>
                  )}
                </PhoenixTheme>
              ) : (
                <>
                  {enableFilterPlacement ? (
                    <>
                      {isSnap ? (
                        <Wrapper marginBottom={3}>{showFilteredData()}</Wrapper>
                      ) : (
                        <>
                          {showFilteredData()}
                          <StyledFilterDivider />
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <BodyText id="sortby-title">
                        {translate('sortAndFilter.sortBy')}
                      </BodyText>
                      {showSortBy()}
                    </>
                  )}
                </>
              )}
            </Wrapper>
            {enableHotelNameSearch && enableSortByV2 && !isMobile && (
              <Wrapper>
                <BodyText id="hotel-class-title">
                  {translate('sortAndFilter.searchPropertyName')}
                </BodyText>
                <PhoenixTheme theme={theme}>
                  <HotelNameSearchWidget
                    theme={theme}
                    move={isMoveEnabled}
                    data={data}
                    locale={locale}
                    lat={lat}
                    lon={lon}
                    clientId={clientId}
                    dest={dest}
                    onSelectDropdownOptions={localOnSelectDropDownOptions}
                    isFullWidth={isHotelNameSearchOptionFullWidth}
                    showSearchIcon={showSearchIconHotelNameSearch}
                    viewport={!isMobile ? DESKTOP_VIEWPORT : MOBILE_VIEWPORT}
                    hotelNameObj={hotelNameObj || draftFilter.hotelNameObj}
                    environment={environment}
                    fireGtm={fireGtm}
                    isHotelSearchWidget={isHotelSearchWidget}
                    isForListingPage={isForListingPage}
                    highlightText
                  />
                </PhoenixTheme>
                <FilterDivider />
              </Wrapper>
            )}
            {
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="price-filter-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('sortAndFilter.priceFilter.yourBudget')}
                          <PerGuestText>
                            {' '}
                            ({translate('common.pricePerRoom')})
                          </PerGuestText>
                        </BodyText>
                      }
                      id="price-filter-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showPriceFilter()}
                      {showPromotionFilterType()}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  <>
                    <BodyText id="price-filter-title" marginBottom={2}>
                      {translate('sortAndFilter.priceFilter.yourBudget')}
                      <PerGuestText>
                        {' '}
                        (
                        {isSnap
                          ? translate(
                              isTotalGuestPriceEnable
                                ? 'hotelCard.totalGuestText'
                                : 'hotelCard.perGuestText'
                            )
                          : translate('common.pricePerRoom')}
                        )
                      </PerGuestText>
                    </BodyText>
                    {showPriceFilter()}
                    {showPromotionFilterType()}
                  </>
                )}
              </Wrapper>
            }
            <Wrapper>
              {showFilterAccordion ? (
                <PhoenixTheme theme={theme}>
                  <Expander
                    label={
                      <BodyText
                        id="guest-rating-title"
                        marginBottom={8}
                        marginTop={8}
                      >
                        {translate('sortAndFilter.guestRating')}
                      </BodyText>
                    }
                    id="guest-rating-title-accordion"
                    afterIcon="ExpandLessIcon"
                    beforeIcon="ExpandMoreIcon"
                    isCompact={true}
                  >
                    {showGuestRatingFilter()}
                  </Expander>
                </PhoenixTheme>
              ) : (
                <>
                  <BodyText id="guest-rating-title" marginBottom={16}>
                    {translate('sortAndFilter.guestRating')}
                  </BodyText>
                  {showGuestRatingFilter()}
                </>
              )}
            </Wrapper>
            {showPropertyType &&
              initialPropertyTypes &&
              initialPropertyTypes.length > 0 && (
                <Wrapper>
                  {showFilterAccordion ? (
                    <PhoenixTheme theme={theme}>
                      <Expander
                        label={
                          <BodyText
                            id="propertyType-class-title"
                            marginBottom={8}
                            marginTop={8}
                          >
                            {translate('common.propertyTypes')}
                          </BodyText>
                        }
                        id="propertyType-title-accordion"
                        afterIcon="ExpandLessIcon"
                        beforeIcon="ExpandMoreIcon"
                        isCompact={true}
                      >
                        {showPropertyTypeFilterSnap(true)}
                      </Expander>
                    </PhoenixTheme>
                  ) : (
                    <>
                      <BodyText id="propertyType-class-title" marginBottom={16}>
                        {translate('common.propertyTypes')}
                      </BodyText>
                      {showPropertyTypeFilterSnap()}
                    </>
                  )}
                </Wrapper>
              )}
            {enableHotelNameSearch && isMobile && (
              <Wrapper>
                <BodyText id="hotel-class-title" marginBottom={16}>
                  {translate('sortAndFilter.searchProperty')}
                </BodyText>
                <PhoenixTheme theme={theme}>
                  <HotelNameSearchWidget
                    theme={theme}
                    move={isMoveEnabled}
                    data={data}
                    locale={locale}
                    lat={lat}
                    lon={lon}
                    clientId={clientId}
                    dest={dest}
                    onSelectDropdownOptions={localOnSelectDropDownOptions}
                    isFullWidth={isHotelNameSearchOptionFullWidth}
                    showSearchIcon={showSearchIconHotelNameSearch}
                    viewport={!isMobile ? DESKTOP_VIEWPORT : MOBILE_VIEWPORT}
                    hotelNameObj={hotelNameObj || draftFilter.hotelNameObj}
                    environment={environment}
                    fireGtm={fireGtm}
                    isHotelSearchWidget={isHotelSearchWidget}
                    isForListingPage={isForListingPage}
                    highlightText
                  />
                </PhoenixTheme>
                <FilterDivider />
              </Wrapper>
            )}
            {showPaymentAndCancellationPolicyFilter && (
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="paymentType-class-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate(
                            'sortAndFilter.paymentAndCancellationPolicy'
                          )}
                        </BodyText>
                      }
                      id="paymentType-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showPaymentTypeFilter()}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  <>
                    <BodyText id="paymentType-title" marginBottom={16}>
                      {translate('sortAndFilter.paymentType')}
                    </BodyText>
                    {showPaymentTypeFilter()}
                  </>
                )}
              </Wrapper>
            )}
            {
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="hotel-class-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('sortAndFilter.hotelClass')}
                        </BodyText>
                      }
                      id="hotel-class-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showHotelStarRatingFilter()}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  <>
                    <BodyText id="hotel-class-title" marginBottom={16}>
                      {translate('sortAndFilter.hotelClass')}
                    </BodyText>
                    {showHotelStarRatingFilter()}
                  </>
                )}
              </Wrapper>
            }
            {enableFreeCancellation && (
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="paymentType-class-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate(
                            'sortAndFilter.paymentAndCancellationPolicy'
                          )}
                        </BodyText>
                      }
                      id="paymentType-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showFreeCancellationFilter()}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  <>
                    <BodyText id="paymentType-title" marginBottom={16}>
                      {translate('sortAndFilter.paymentType')}
                    </BodyText>
                    {showFreeCancellationFilter()}
                  </>
                )}
              </Wrapper>
            )}
            {isShowChecklist && (
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="amenities-rating-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('common.amenities')}
                        </BodyText>
                      }
                      id="amenities-rating-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showAmenitiesFilter()}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  <>
                    <BodyText id="amenities-rating-title" marginBottom={16}>
                      {translate('common.amenities')}
                    </BodyText>
                    {showAmenitiesFilter()}
                  </>
                )}
              </Wrapper>
            )}
            {isShowInputFilter && (
              <Wrapper>
                <FilterDivider />
                <BodyText id="guest-rating-title" marginBottom={16}>
                  {translate('sortAndFilter.searchProperty')}
                </BodyText>
                <PhoenixTheme theme={theme}>
                  <DropDown
                    viewPort={!isMobile ? DESKTOP_VIEWPORT : MOBILE_VIEWPORT}
                    defaultValue={defaultItem}
                    items={listFilterItems}
                    label={filterPlaceHolder}
                    onChange={onfilterChangeValue}
                    onClear={onClearFilter}
                    onSelect={onSelectFilter}
                    width={'100%'}
                    locale={confFilterLocale}
                    alwaysShowLabel
                    supportOneCharacterSearch
                    isShowCancel={true}
                    hideLabelWhenFocus
                    cancelIconColor={cancelIconColor}
                    showSearchFor
                    noneHighLightInput
                    backgroundColorItems="default"
                    hideRecentLabel
                  ></DropDown>
                </PhoenixTheme>
              </Wrapper>
            )}
            {isNeighborhoodFilterEnabled && (
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="NeighbourhoodFilter-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('sortAndFilter.neighbourhood.title')}
                        </BodyText>
                      }
                      id="NeighbourhoodFilter-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showNeighbourhoodFilter(true)}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  showNeighbourhoodFilter()
                )}
              </Wrapper>
            )}
            {isLocationFilterEnabled && (
              <Wrapper>
                {showFilterAccordion ? (
                  <PhoenixTheme theme={theme}>
                    <Expander
                      label={
                        <BodyText
                          id="locationFilter-title"
                          marginBottom={8}
                          marginTop={8}
                        >
                          {translate('locationFilter.title')}
                        </BodyText>
                      }
                      id="locationFilter-title-accordion"
                      afterIcon="ExpandLessIcon"
                      beforeIcon="ExpandMoreIcon"
                      isCompact={true}
                    >
                      {showlocationFilter(true)}
                    </Expander>
                  </PhoenixTheme>
                ) : (
                  showlocationFilter()
                )}
              </Wrapper>
            )}
          </Wrapper>
        </>
      )}
      {isMobile && (
        <FilterFooter
          zIndex={isMobile && isShowChecklist ? '2' : 'auto'}
          backgroundColor={'#FFFFFF'}
          padding={16}
        >
          <Button
            id="apply-filter-btn"
            big
            block
            onClick={() => {
              updateFilter(draftFilter);
              showPaymentAndCancellationPolicyFilter &&
                paymentAndCancellationPolicyHandler(draftFilter.paymentType);
              enableFreeCancellation &&
                paymentAndCancellationPolicyHandler(draftFilter.paymentType);
              hotelClassSelectionHandler(draftFilter.hotelClass);
              showPropertyType &&
                propertyTypeSelectionHandler(draftFilter.propertyType);
              isLocationFilterEnabled &&
                locationSelectionHandler(locationObject);
              isNeighborhoodFilterEnabled &&
                neighborhoodSelectionHandler(neighbourhoodObject);
              priceFilterHandler(draftFilter.priceFilter);
              isShowChecklist && sendAmenitiesId(amenities);
              showPromotionFilter &&
                promotionFilterSelectionHandler(draftFilter.promotions);
              onApplyButtonClick();
              closeModal();
              if (onUpdateFilterTrigger) onUpdateFilterTrigger();
              //remove style body
              if (isShowInputFilter) {
                const body = document.getElementsByTagName('body');
                if (body) {
                  body[0].removeAttribute('style');
                }
              }
            }}
            move={isMoveEnabled}
            backgroundColor={isMoveEnabled && '#0CE865'}
            border={isMoveEnabled && '#023C40'}
            borderRadius={isMoveEnabled && '32px'}
            hovercolor={isMoveEnabled && '#12C25A'}
          >
            {translate('sortAndFilter.apply')}
          </Button>
        </FilterFooter>
      )}
    </>
  );
};
SortAndFilter.propTypes = {
  isMobile: bool,
  closeModal: func,
  filter: object,
  updateFilter: func,
  clearFilter: func,
  hasMapView: bool,
  hotelClassSelectionHandler: func,
  isShowChecklist: bool,
  sendAmenitiesId: func,
  initialAmenities: array,
  isShowInputFilter: bool,
  listFilterItems: array,
  defaultItemFilter: object,
  filterPlaceHolder: string,
  searchInputHandle: func,
  onClear: func,
  onSelectItemFilter: func,
  locationOptions: array,
  isLocationFilterEnabled: bool,
  confFilterLocale: object,
  cancelIconColor: string,
  selectedLocationId: string,
  locationSelectionHandler: func,
  isEmpty: bool,
  onUpdateFilterTrigger: func,
  data: object,
  locale: string,
  lat: number,
  lon: number,
  clientId: string,
  dest: string,
  onSelectDropdownOptions: func,
  enableHotelNameSearch: bool,
  isHotelNameSearchOptionFullWidth: bool,
  showSearchIconHotelNameSearch: bool,
  onApplyButtonClick: func,
  hotelNameObj: object,
  resetHotelName: func,
  showAbleLocationLength: number,
  environment: string,
  sortBySelectionHandler: func,
  guestRatingSelectionHandler: func,
  priceFilterHandler: func,
  userLocationSelected: string,
  showAbleAmenityLength: number,
  showFilterAccordion: bool,
  lob: string,
  isNeighborhoodFilterEnabled: bool,
  neighborhoodSelectionHandler: func,
  neighborhoodOptions: array,
  resetLocationFilter: bool,
  setResetLocationFilter: bool,
  showPaymentAndCancellationPolicyFilter: bool,
  enableFreeCancellation: bool,
  paymentAndCancellationPolicyHandler: func,
  fireGtm: func,
  isHotelSearchWidget: bool,
  isForListingPage: bool,
  showPropertyType: bool,
  propertyTypeSelectionHandler: func,
  initialPropertyTypes: func,
  showAblePropertyTypeLength: number,
  isSnap: bool,
  isHotel: bool,
  hotel: object,
  showPromotionFilter: bool,
  promotionFilterSelectionHandler: func,
  showPromotionFilterCheckBox: bool,
  filteredData: array,
  localizedText: func,
  unFilter: func,
  enableFilterPlacement: bool,
  enableFilterRearrange: bool,
  enablePayNowFilter: bool,
  enableSortByV2: bool,
  enableGuestRatingDeselect: bool,
  theme: string,
  isMoveEnabled: bool,
  enablePayLaterFilter: bool,
  priceRange: array,
  enablePriceBucketsConfig: bool,
  isTotalGuestPriceEnable: bool,
};
SortAndFilter.defaultProps = {
  isMobile: false,
  closeModal: () => {},
  filter: {},
  updateFilter: () => {},
  clearFilter: () => {},
  hotelClassSelectionHandler: () => {},
  isShowChecklist: false,
  isShowInputFilter: false,
  listFilterItems: [],
  defaultItemFilter: {},
  filterPlaceHolder: '',
  searchInputHandle: () => {},
  onClear: () => {},
  onSelectItemFilter: () => {},
  locationOptions: [],
  isLocationFilterEnabled: false,
  confFilterLocale: LOCALE,
  selectedLocationId: '',
  locationSelectionHandler: () => {},
  isEmpty: false,
  onUpdateFilterTrigger: () => {},
  enableHotelNameSearch: false,
  isHotelNameSearchOptionFullWidth: false,
  showSearchIconHotelNameSearch: true,
  showAbleLocationLength: 3,
  environment: 'STAGING',
  resetHotelName: () => {},
  sortBySelectionHandler: () => {},
  guestRatingSelectionHandler: () => {},
  priceFilterHandler: () => {},
  showAbleAmenityLength: 6,
  showFilterAccordion: false,
  lob: 'SNAP',
  isNeighborhoodFilterEnabled: false,
  neighborhoodSelectionHandler: () => {},
  neighborhoodOptions: [],
  showPaymentAndCancellationPolicyFilter: false,
  enableFreeCancellation: false,
  enablePayNowFilter: false,
  paymentAndCancellationPolicyHandler: () => {},
  fireGtm: () => {},
  isHotelSearchWidget: false,
  isForListingPage: false,
  showPropertyType: false,
  propertyTypeSelectionHandler: () => {},
  initialPropertyTypes: () => {},
  showAblePropertyTypeLength: 4,
  showPromotionFilter: false,
  promotionFilterSelectionHandler: () => {},
  isSnap: false,
  showPromotionFilterCheckBox: true,
  filteredData: [],
  localizedText: () => {},
  unFilter: () => {},
  enableFilterPlacement: false,
  enableSortByV2: false,
  enableGuestRatingDeselect: false,
  theme: 'AIRASIA_CLASSIC',
  isMoveEnabled: false,
  enablePayLaterFilter: true,
  priceRange: [],
  enablePriceBucketsConfig: false,
  isTotalGuestPriceEnable: false,
};
export default SortAndFilter;
